import { Image, Transformer } from "react-konva";
import React, { useEffect, useRef } from "react";
import useImage from "use-image";

export const URLImage = ({
  image,
  isSelected,
  onSelect,
  isDrawing,
  handleDragEnd,
  dragStart,
  transformEnd,
  control,
  openContext,
}) => {
  const [img] = useImage(image.src);

  const imgRef = useRef(null);
  const trRef = useRef(null);

  const offsetX = img ? parseInt(image.width, 10) / 2 : 0;
  const offsetY = img ? parseInt(image.height, 10) / 2 : 0;

  const canvasWidth = 850;
  const canvasHeight = 650;

  const contextHandler = (e) => {
    e.evt.preventDefault();
    e.cancelBubble = true;
    openContext(e.evt, image.id);
  };

  useEffect(() => {
    if (!isSelected) return;
    if (!imgRef.current || !trRef.current) return;

    const imageNode =
      typeof imgRef.current.getNode === "function"
        ? imgRef.current.getNode() || imgRef.current
        : imgRef.current;

    const transformerNode =
      typeof trRef.current.getNode === "function"
        ? trRef.current.getNode() || trRef.current
        : trRef.current;

    if (typeof transformerNode.nodes === "function") {
      transformerNode.nodes([imageNode]);
    } else if (typeof transformerNode.attachTo === "function") {
      transformerNode.attachTo(imageNode);
    } else if (typeof transformerNode.setNode === "function") {
      transformerNode.setNode(imageNode);
    }

    if (typeof transformerNode.forceUpdate === "function") {
      transformerNode.forceUpdate();
    }

    const layer = imageNode.getLayer();
    if (layer) {
      layer.batchDraw();
    }
  }, [isSelected, image.x, image.y, image.rotation, image.scaleX, image.scaleY]);

  return (
    <>
      <Image
        ref={imgRef}
        name="selectable-piece"
        image={img}
        x={image.x}
        y={image.y}
        id={String(image.id)}
        dataId={image.dataId}
        rotation={image.rotation || 0}
        scaleX={image.scaleX !== undefined ? image.scaleX : 1}
        scaleY={image.scaleY !== undefined ? image.scaleY : 1}
        onMouseDown={(e) => {
          e.cancelBubble = true;
          onSelect && onSelect(String(image.id));
        }}
        onTap={(e) => {
          e.cancelBubble = true;
          onSelect && onSelect(String(image.id));
        }}
        onContextMenu={contextHandler}
        dragBoundFunc={(pos) => {
          let newY = pos.y < 10 ? 10 : pos.y;
          newY = newY > canvasHeight ? canvasHeight : newY;

          let newX = pos.x < 10 ? 10 : pos.x;
          newX = newX > canvasWidth ? canvasWidth : newX;

          return { x: newX, y: newY };
        }}
        width={parseInt(image.width, 10)}
        height={parseInt(image.height, 10)}
        offsetX={offsetX}
        offsetY={offsetY}
        draggable={isDrawing === true ? false : control === true}
        onDragEnd={handleDragEnd}
        onDragStart={dragStart}
        onTransformEnd={transformEnd}
      />

      {control && isSelected && (
        <Transformer
          ref={trRef}
          resizeEnabled={false}
          rotateEnabled={true}
          borderEnabled={true}
          anchorSize={14}
          anchorStroke="red"
          anchorFill="white"
          borderStroke="red"
          borderStrokeWidth={2}
          rotateAnchorOffset={30}
          flipEnabled={true}
          boundBoxFunc={(oldBox, newBox) => {
            if (newBox.width < 5 || newBox.height < 5) {
              return oldBox;
            }
            return newBox;
          }}
        />
      )}
    </>
  );
};